export const TestTypes = Object.freeze({
    BASIC: 'Basic',
    BIZARRE: 'Bizarre',
    EDGE_CASES: 'Edge cases',
    HIGH_PROBABILITY_BUGS: 'High probability bug finding cases',
    FUNCTIONAL: 'Functional',
    POSITIVE: 'Positive',
    NEGATIVE: 'Negative',
    PERFORMANCE: 'Performance/Load/Stress',
    SECURITY: 'Security/Compatibility/Accessibility',
    UI_SPECIFIC: 'UI specific',
    BACKEND: 'Backend',
});
